/** Check if the current environment is JSDOM */
export const isJSDOM = () => navigator.userAgent.includes('jsdom')
